// ==================== CAPABILITY MODELS ====================

export const CAPABILITY_MODELS = {
  aiCapabilities: {
    'Data Management': {
      subCapabilities: ['Data Governance', 'Data Quality', 'Data Integration', 'Master Data Management'],
      maturityIndicators: {
        1: 'No formal data management',
        2: 'Basic data collection',
        3: 'Data governance in place',
        4: 'Automated data pipelines',
        5: 'Self-service data platform'
      }
    },
    'Model Development': {
      subCapabilities: ['Feature Engineering', 'Model Training', 'Model Evaluation', 'Model Selection'],
      maturityIndicators: {
        1: 'Ad-hoc model building',
        2: 'Basic ML models',
        3: 'Standardized process',
        4: 'Automated ML',
        5: 'Self-learning systems'
      }
    },
    'MLOps': {
      subCapabilities: ['CI/CD', 'Monitoring', 'Versioning', 'Deployment'],
      maturityIndicators: {
        1: 'Manual deployment',
        2: 'Basic automation',
        3: 'CI/CD pipeline',
        4: 'Full MLOps',
        5: 'Zero-touch operations'
      }
    },
    'AI Governance': {
      subCapabilities: ['Ethics', 'Compliance', 'Risk Management', 'Auditability'],
      maturityIndicators: {
        1: 'No governance',
        2: 'Basic guidelines',
        3: 'Formal governance',
        4: 'Automated compliance',
        5: 'Continuous assurance'
      }
    },
    'Business Integration': {
      subCapabilities: ['Process Integration', 'Change Management', 'Value Tracking', 'Stakeholder Management'],
      maturityIndicators: {
        1: 'Isolated projects',
        2: 'Departmental adoption',
        3: 'Cross-functional',
        4: 'Enterprise-wide',
        5: 'AI-native organization'
      }
    }
  },
  
  transformationCapabilities: {
    'Strategic Alignment': {
      description: 'Ability to align AI initiatives with business strategy',
      keyQuestions: ['Is AI part of business strategy?', 'Are KPIs aligned?', 'Is there executive sponsorship?']
    },
    'Organizational Readiness': {
      description: 'Organization readiness for AI transformation',
      keyQuestions: ['Is there a change management plan?', 'Are skills available?', 'Is culture ready?']
    },
    'Technology Foundation': {
      description: 'Technology readiness for AI',
      keyQuestions: ['Is infrastructure scalable?', 'Are tools standardized?', 'Is security adequate?']
    },
    'Data Readiness': {
      description: 'Data readiness for AI',
      keyQuestions: ['Is data quality sufficient?', 'Is data accessible?', 'Is data governed?']
    }
  }
};

export const CAPABILITY_ASSESSMENT_QUESTIONS = [
  {
    dimension: 'Strategic Alignment',
    questions: [
      { question: 'AI is part of our business strategy', weight: 5 },
      { question: 'We have executive sponsorship for AI', weight: 5 },
      { question: 'AI KPIs are aligned with business KPIs', weight: 4 },
      { question: 'We have a clear AI roadmap', weight: 4 }
    ]
  },
  {
    dimension: 'Organizational Readiness',
    questions: [
      { question: 'We have sufficient AI talent', weight: 5 },
      { question: 'Our culture supports innovation', weight: 4 },
      { question: 'We have change management processes', weight: 4 },
      { question: 'Employees are trained on AI', weight: 3 }
    ]
  },
  {
    dimension: 'Technology Foundation',
    questions: [
      { question: 'Our infrastructure is scalable', weight: 5 },
      { question: 'We use modern ML tools', weight: 4 },
      { question: 'We have MLOps practices', weight: 4 },
      { question: 'Security is built into our processes', weight: 5 }
    ]
  },
  {
    dimension: 'Data Readiness',
    questions: [
      { question: 'Our data quality is sufficient', weight: 5 },
      { question: 'Data is accessible to teams', weight: 4 },
      { question: 'We have data governance', weight: 5 },
      { question: 'We have sufficient data volume', weight: 4 }
    ]
  }
];